module.exports = __webpack_public_path__ + "static/img/banner-default-en.704f6e52.png";